module.exports = __webpack_public_path__ + "media/images/donation/logo-ieon-544871f6ddfd86dbd0837fba065224af.jpg";